import type { FaireProductEntity } from "../../entity_types/product";

export const p_mszh427ejw: FaireProductEntity = {
  token: "p_mszh427ejw",
  type: "product",
  name: "Lavender Market Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/a986c09ee84eaf59f5e64cc90f52fe583dd70ef22d42d22fefce24137c1cc57d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c6b8ca924e403fc9cfb7759b71228820e8932a64c49cffc91e808333aa843813.png",
    "https://cdn.faire.com/fastly/3eac0aab0ce3920eabe0a5b0d6b1455c75248b58ebc20215f7b96c8aec38c58b.png",
    "https://cdn.faire.com/fastly/5c1948e087aee1059f5a282234b51badf21709ad081bcf6643ca56caa6d2cc50.png",
  ],
  priceDollars: 8,
  description:
    "Ah, the ol' kitchen list. As soon as you've gotten everything on it, it's time to start a new one. So add cheer to the chore with a cute notepad! It might even make you smile as you write down salad. Again.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:57.199Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
